import { Trash2 } from "lucide-react";
import React from "react";
import { useEditorShortcuts } from "../../../shortcuts/EditorShortcutContext/useEditorShortcuts";
import { ShapeControlButton } from "./ShapeControlButton";
import { ShapeDeleteControlProps } from "./types";

export const ShapeControlDelete: React.FC<ShapeDeleteControlProps> = ({
  onDelete
}) => {
  const { shortcuts } = useEditorShortcuts();

  return (
    <ShapeControlButton
      isDestructive
      onClick={() => onDelete()}
      title={"Delete"}
      icon={Trash2}
      shortcut={shortcuts.shapeSelection.delete}
    />
  );
};
